import { render, staticRenderFns } from "./ProductsPreview.vue?vue&type=template&id=983a9936&"
import script from "./ProductsPreview.vue?vue&type=script&lang=js&"
export * from "./ProductsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports